






import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Error extends Vue {
  
  @Prop({ default: '',  type: String}) label!: string;
}
